import React, { ReactElement } from 'react';
import { FdrTextBlock } from '@hotelplan/fdr.regular.basis.fdr-text-block';
import {
  AgencyOverviewHeroWrapper,
  FdrAgencyOverviewContent,
} from 'components/domain/fdr-agency-overview';
import { FdrHeroSection } from 'components/domain/fdr-hero-section';
import { FdrPageComponents } from 'components/domain/fdr-page-components';
import { TextBlockContainer } from 'components/domain/text-block/TextBlockContainer';
import { fdrAgencyOverviewPageVars } from 'components/page/agency-overview/agency-overview.vars';
import { useFdrAgencyOverviewQuery } from 'schemas/query/agency-overview/fdr-agency-overview.generated';

export { getServerSideProps } from 'components/page/agency-overview/agency-overview.gssp';

export default function AgencyOverviewPage(): ReactElement {
  const queryResult = useFdrAgencyOverviewQuery({
    variables: fdrAgencyOverviewPageVars,
  });

  const { hero, pageComponents, text, title, flagline } =
    queryResult?.data?.fdrAgencyOverviewPage || {};

  return (
    <>
      {hero ? (
        <AgencyOverviewHeroWrapper>
          <FdrHeroSection title={title} text={flagline} hero={hero} />
        </AgencyOverviewHeroWrapper>
      ) : null}
      <TextBlockContainer>
        <FdrTextBlock text={text} />
      </TextBlockContainer>
      <FdrAgencyOverviewContent />
      <FdrPageComponents components={pageComponents.components} />
    </>
  );
}
